import React from 'react';
import './DataTable.css';

/**
 * DataTable Component
 * @param {Array}  columns    - [{key, label, render?, width?}]
 * @param {Array}  data       - array of row objects
 * @param {string} emptyText  - text when no rows
 * @param {boolean} striped
 * @param {boolean} hoverable
 */
/**
 * DataTable Component
 * @param {Array}    columns    - [{key, label, render?, width?, sortable?}]
 * @param {Array}    data       - array of row objects
 * @param {string}   emptyText  - text when no rows
 * @param {boolean}  striped
 * @param {boolean}  hoverable
 * @param {object}   sortConfig - { key, direction: 'asc'|'desc' }
 * @param {function} onSort     - Callback when header clicked
 */
const DataTable = ({
  columns = [],
  data = [],
  emptyText = 'No records found.',
  striped = true,
  hoverable = true,
  className = '',
  sortConfig = null,
  onSort = null,
}) => {
  return (
    <div className={`table-container ${className}`}>
      <table className={`data-table ${striped ? 'data-table--striped' : ''} ${hoverable ? 'data-table--hoverable' : ''}`}>
        <thead className="data-table__head">
          <tr>
            {columns.map((col) => {
              const isSorted = sortConfig?.key === col.key;
              const direction = isSorted ? sortConfig.direction : null;

              return (
                <th
                  key={col.key}
                  className={`data-table__th ${col.sortable ? 'data-table__th--sortable' : ''}`}
                  style={col.width ? { width: col.width } : undefined}
                  onClick={() => col.sortable && onSort?.(col.key)}
                >
                  <div className="table-header-inner">
                    {col.label}
                    {col.sortable && (
                      <span className={`sort-indicator ${isSorted ? 'sort-indicator--active' : ''}`}>
                        {direction === 'asc' ? '↑' : direction === 'desc' ? '↓' : '↕'}
                      </span>
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="data-table__body">
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="data-table__empty">
                <div className="table-empty-state">
                  <span className="table-empty-icon">📭</span>
                  <p>{emptyText}</p>
                </div>
              </td>
            </tr>
          ) : (
            data.map((row, rowIdx) => (
              <tr key={row.IssueId ?? row.CollectionId ?? row.AccessionNo ?? row.id ?? rowIdx} className="data-table__row">
                {columns.map((col) => (
                  <td key={col.key} className="data-table__td">
                    {col.render ? col.render(row[col.key], row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;

